// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 2H2V4H3V18H9.58579L5.58579 22L7 23.4142L12 18.4142L17 23.4142L18.4142 22L14.4142 18H21V4H22V2ZM14.6667 10L10 13.5V6.5L14.6667 10Z"}}]};

const PlayDemoFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'play-demo-filled',
    ref,
    icon: element,
  },
));

PlayDemoFilledIcon.displayName = 'PlayDemoFilledIcon';

export default PlayDemoFilledIcon;
